// Module
var code = "<select class=\"b-select\" ng-class=\"{'-style_placeholder' : (vm.model == 0)}\" ng-model=\"vm.model\" ng-options=\"option.id as option.name for option in vm.options\"></select> ";
// Exports
module.exports = code;